import React, { Component } from "react";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import Cookies from "universal-cookie";
import Moment from "react-moment";
import {
  HashLink 
} from "react-router-hash-link";

const cookies = new Cookies();

const FooterQuery = gql`
query footer {
  themeGeneralSettings {
    optionsPage {
      scrollToTopIcon {
        sourceUrl(size: LARGE)
      }
      footerLeftEn
      footerLeftLv
      footerRightEn
      footerRightLv

    }
  }
}

`;

class FooterPage extends Component {
  render() {
    const {
      data: { loading, themeGeneralSettings }
    } = this.props;
    return (
      <div id="footerPage" className="container mb-3">
            
         {!loading && themeGeneralSettings && (
          
      <div className="row">
          <div className="col-12"><span className="footerLeft">{cookies.get("lang") === "LV" &&
              <span dangerouslySetInnerHTML = {
                {
                  __html: this.props.data.themeGeneralSettings.optionsPage.footerLeftLv
                }
              }
              />}
            {cookies.get("lang") === "EN" &&
              <span dangerouslySetInnerHTML = {
                {
                  __html: this.props.data.themeGeneralSettings.optionsPage.footerLeftEn
                }
              }
              />}
          </span>
          <span className="footerRight">{cookies.get("lang") === "LV" && <span  dangerouslySetInnerHTML={
                {
                  __html: this.props.data.themeGeneralSettings.optionsPage.footerRightLv
                }
              } />
              
              }
            {cookies.get("lang") === "EN" &&
              <span dangerouslySetInnerHTML = {
                {
                  __html: this.props.data.themeGeneralSettings.optionsPage.footerRightEn
                }
              }
              />} <Moment format="YYYY"></Moment >
          </span>
              <div className="scrollToTopWrap">
                <HashLink smooth to="#">
                  <img src={
                  this.props.data.themeGeneralSettings.optionsPage.scrollToTopIcon.sourceUrl
                } alt="totop" /> </HashLink>
                
                </div>
              
        </div>
      </div>
        )}
    </div>);
  }
}

export default graphql(FooterQuery)(FooterPage);
